export default __webpack_public_path__ + "static/media/menu.5510e546.svg";